import { Injectable } from "@angular/core";
import { ConfigService } from './config.service';

@Injectable({
  providedIn:'root'
})
export class PreconnectService {
  
  constructor(
    private configService: ConfigService,
  ) {}

  addPreconnects(): void {
    const preConnectUrls = this.configService.getPreconnectUrls?.split(',');
    if(preConnectUrls && preConnectUrls.length > 0) {
      preConnectUrls.forEach(url => {
      const linkElement = document.createElement('link');
      linkElement.rel = 'preconnect';
      linkElement.href = url;
      document.head.appendChild(linkElement);
    });
    }
  }

  
}
